import { render } from "./bussinessReg.vue?vue&type=template&id=3c3bca6e&scoped=true"
import script from "./bussinessReg.vue?vue&type=script&lang=js"
export * from "./bussinessReg.vue?vue&type=script&lang=js"

import "./bussinessReg.vue?vue&type=style&index=0&id=3c3bca6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3bca6e"]])

export default __exports__